<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__wrapper">
        <div class="footer__column">
          <img src="@images/logo.png" alt="logo">
          <div class="footer__column-company">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.75 1.75C12.6525 1.75 15 4.0975 15 7C15 10.9375 9.75 16.75 9.75 16.75C9.75 16.75 4.5 10.9375 4.5 7C4.5 4.0975 6.8475 1.75 9.75 1.75ZM6 7C6 9.1375 8.19 12.4075 9.75 14.41C11.34 12.3925 13.5 9.16 13.5 7C13.5 4.93 11.82 3.25 9.75 3.25C7.68 3.25 6 4.93 6 7ZM9.75 8.875C8.71447 8.875 7.875 8.03553 7.875 7C7.875 5.96447 8.71447 5.125 9.75 5.125C10.7855 5.125 11.625 5.96447 11.625 7C11.625 8.03553 10.7855 8.875 9.75 8.875Z" fill="#D596FF"/>
            </svg>
            <p>{{ companyAddress }}</p>
          </div>
          <div class="footer__column-company">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 5.25C17.25 4.425 16.575 3.75 15.75 3.75H3.75C2.925 3.75 2.25 4.425 2.25 5.25V14.25C2.25 15.075 2.925 15.75 3.75 15.75H15.75C16.575 15.75 17.25 15.075 17.25 14.25V5.25ZM15.75 5.25L9.75 9L3.75 5.25H15.75ZM15.75 14.25H3.75V6.75L9.75 10.5L15.75 6.75V14.25Z" fill="#D596FF"/>
            </svg>
            <a :href="'mailto:' + companyEmail">{{ companyEmail }}</a>
          </div>
          <div class="footer__column-company">
            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.655 3.75C5.7 4.4175 5.8125 5.07 5.9925 5.6925L5.0925 6.5925C4.785 5.6925 4.59 4.74 4.5225 3.75H5.655ZM13.05 12.7646C13.6875 12.9446 14.34 13.0571 15 13.1021V14.2196C14.01 14.1521 13.0575 13.9571 12.15 13.6571L13.05 12.7646ZM6.375 2.25H3.75C3.3375 2.25 3 2.5875 3 3C3 10.0425 8.7075 15.75 15.75 15.75C16.1625 15.75 16.5 15.4125 16.5 15V12.3825C16.5 11.97 16.1625 11.6325 15.75 11.6325C14.82 11.6325 13.9125 11.4825 13.0725 11.205C12.9975 11.175 12.915 11.1675 12.84 11.1675C12.645 11.1675 12.4575 11.2425 12.3075 11.385L10.6575 13.035C8.535 11.9475 6.795 10.215 5.715 8.0925L7.365 6.4425C7.575 6.2325 7.635 5.94 7.5525 5.6775C7.275 4.8375 7.125 3.9375 7.125 3C7.125 2.5875 6.7875 2.25 6.375 2.25Z" fill="#D596FF"/>
            </svg>
            <a :href="'tel:' + companyPhone">{{ companyPhone }}</a>
          </div>
        </div>
        <div class="footer__block">
          <div class="footer__column">
            <p class="footer__column-title">{{ t('footer.company') }}</p>
            <div>
              <router-link :to="translations.i18nRoute({ name: 'faq' })" class="footer__column-text">FAQ</router-link>
              <router-link :to="translations.i18nRoute({ name: 'terms-and-conditions' })" class="footer__column-text">{{ t('footer.nav.terms') }}</router-link>
              <router-link :to="translations.i18nRoute({ name: 'privacy-policy' })" class="footer__column-text">{{ t('footer.nav.privacy') }}</router-link>
              <p class="footer__column-text" @click="scrollTo('whyContact', 'home')">{{ t('footer.nav.contact') }}</p>
            </div>
          </div>
          <div class="footer__column">
            <p class="footer__column-title">{{ t('footer.services') }}</p>
            <div>
              <router-link
                  v-for="category of categories"
                  :key="category.node.uuid"
                  :to="translations.i18nRoute({ name: 'store', params: { category: category.node.slug } })"
                  class="footer__column-text"
              >
                {{ category.node.name }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="footer__right">
          <div class="footer__images">
            <div class="footer__images-inner">
              <img class="footer__images-image1" src="@icons/visa.png" alt="visa">
              <img class="footer__images-image2" src="@icons/visaSecure.jpg" alt="visa secure">
            </div>
            <div class="footer__images-inner">
              <img class="footer__images-image3" src="@icons/mastercard.png" alt="mastercard">
              <img class="footer__images-image4" src="@icons/mastercardIDCheck.png" alt="mastercard id">
            </div>
          </div>
          <div class="footer__right-bottom">
            <a
                href="https://t.me/fptemplates"
                target="_blank"
                class="footer__social"
            >
              <img src="@icons/telegramIcon.png" alt="telegram">
            </a>
            <base-language />
          </div>
        </div>
      </div>
    </div>
    <p class="footer__copy">© {{ actualYear }} {{ companyName }} {{ t('footer.copyright') }}</p>
  </footer>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed, onMounted, ref, watch} from "vue";
import {useCompanyStore} from "@/stores/company.js";
import {scroll} from "@/core/helpers/scrollTo.js";
import {useRoute, useRouter} from "vue-router";
import {Categories} from "@/core/api/categories.js";
import translations from "@/core/helpers/translations.js";
import BaseLanguage from "@/components/base/base-language.vue";

const {t, locale} = useI18n()
const route = useRoute()
const companyStore = useCompanyStore()
const router = useRouter()

const company = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})
const companyName = computed(() => {
  if (!company.value?.companyName) return '';
  return company.value?.companyName.split(',')[0].trim();
});
const companyEmail = computed(() => {
  return company.value?.emailFrom || '';
});
const companyPhone = computed(() => {
  return company.value?.companyPhoneNumber || '';
});
const companyAddress = computed(() => {
  return company.value?.companyAddress || '';
});

const actualYear = computed(() => new Date().getFullYear());

const scrollTo = (id, routeName) => {
  if (route.name === routeName) {
    scroll(id)
  } else {
    router.push({
      name: routeName
    }).then(scroll(id, 500));
  }
}

const categories = ref([])

const getCategories = async () => {
  const res = await Categories.getCategories()
  categories.value = res.data.categories.edges
}

watch(locale, async () => {
  await getCategories()
})

onMounted( async () => {
  await getCategories()

  if (window.Trustpilot) {
    const box = document.getElementById('trustbox')
    const a = window.Trustpilot.loadFromElement(box)
  }
})
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  background-color: $white;
  box-shadow: 0px -3px 15.3px 0px rgba(0, 0, 0, 0.10);

  &__wrapper {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
  }

  &__column {
    padding-block: 62px 30px;
    display: flex;
    flex-direction: column;
    gap: 30px;

    & img {
      width: 140px;
    }

    &-company {
      display: flex;
      flex-direction: row !important;
      align-items: flex-start;
      gap: 12px;
      max-width: 250px;
      transition: 0.2s;

      color: #77808B;
      font-size: 13px;
      font-weight: 500;

      & a:hover {
        color: #5c646e;
      }

      & svg {
        flex-shrink: 0;
      }
    }

    &-title {
      color: #0455C0;
      font-size: 20px;
      font-weight: 500;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: auto;
      text-decoration-thickness: 5.5%; /* 1.1px */
      text-underline-offset: auto;
      text-underline-position: from-font;
    }

    & div {
      display: flex;
      flex-direction: column;
      gap: 7px;
    }

    &-text {
      cursor: pointer;
      transition: 0.2s;

      color: #000;
      font-size: 16px;
      font-weight: 500;

      &:hover {
        color: #3b3b3b;
      }
    }

    &-language {
      justify-self: flex-end;
    }

    &-links {
      align-self: center;
      display: flex;
      flex-direction: row !important;
      align-items: center;
      gap: 20px !important;
    }

    &-link {
      & svg {
        color: #FFCF96;
      }

      &:hover {
        & svg {
          color: #ffbd6e;
        }
      }
    }
  }

  &__block {
    background-color: #FBF2FF;
    padding-bottom: 100px;
    padding-inline: 40px;
    display: flex;
    align-items: flex-start;
    gap: 90px;
  }

  &__right {
    padding-top: 62px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 75px;

    &-bottom {
      display: flex;
      align-items: center;
      gap: 25px;
    }
  }

  &__social {
    display: block;

    & img {
      display: block;
      width: 35px;
    }
  }

  &__images {
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;

    &-inner {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: center;
      height: 78px;
      justify-content: space-between;
    }

    &-image1 {
      width: 55px;
      height: 18px;
    }
    &-image2 {
      width: 50px;
      height: 50px;
    }
    &-image3 {
      width: 100px;
      height: 23px;
    }
    &-image4 {
      width: 98px;
      height: 35px;
    }
  }

  &__copy {
    width: 100%;
    background-color: #BE8AFF;
    padding-block: 8px;

    color: #545F6D;
    text-align: center;
    font-size: 13px;
    font-weight: 500;
  }
}

@media (max-width: 1680px) {
  .footer {
    &__block {
      gap: 25px;
      padding-inline: 30px;
    }
  }
}

@media (max-width: 1300px) {
  .footer {
    &__wrapper {
      flex-direction: column;
      align-items: center;
      gap: 30px;
      padding-bottom: 25px;
    }

    &__column {
      width: 100%;
      align-items: center;
    }

    &__block {
      width: 100%;
    }
  }
}

@media (max-width: 600px) {
  .footer {
    &__block {
      flex-direction: column;
      gap: 0;
    }

    &__column div {
      align-items: center;
    }
  }
}

@media (max-width: 400px) {
  .footer {
    &__block {
      gap: 30px;
    }
  }
}
</style>